module.exports = __webpack_public_path__ + "media/images/badges/rumble/milestone-10-Inactive-Rumble-2d51aa001f8fa8b7adff20be0ed2daf0.png";